import React from 'react';
import { Card, Typography } from '@material-ui/core';
import { userLanguage } from '../../../../core/AuthContext';
import { GQLSymbolAsset } from '@jewelutions/core-crm-server-api-client-domain';
import { SvgDisplay } from '../../../../components';

interface IProps {
  symbolAsset: GQLSymbolAsset;
}

const SymbolsDetails: React.FC<IProps> = ({ symbolAsset }) => {
  return (
    <Card style={{ alignItems: 'center' }} variant="outlined">
      <Typography style={{ alignContent: 'center' }} variant="h4">
        {symbolAsset.symbol.title[userLanguage]}
      </Typography>

      {symbolAsset.symbol.media?.url && (
        <SvgDisplay style={{ width: '128px', height: '128px' }} url={symbolAsset.symbol.media?.url} />
      )}
      {!symbolAsset.symbol.media?.url && (
        <img height={40} style={{ color: 'red' }} src={'/images/x-mark-128.png'}></img>
      )}
    </Card>
  );
};
export default SymbolsDetails;
